import { Component, OnInit,TemplateRef } from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";


@Component({
  selector: "app-footer-web",
  templateUrl: "./footer-web.component.html",
})
export class FooterWebComponent implements OnInit {
  modalRef: BsModalRef;

  constructor(private modalService: BsModalService) {}

  ngOnInit() {}

  public openModal(template: TemplateRef<any>): void {
    this.modalRef = this.modalService.show(template, {backdrop : 'static', keyboard : false, class: 'popup-center-new modal-lg' });
  }
  public close(){
    this.modalRef.hide();
  }
}
